const StakeHeading = () => {
    return (
        <div className="component-container rounded-2xl p-6 flex flex-col items-center">
            <span className="size-3">Títan Stake</span>
            <span className="py-3">
                Stake Títan tokens and receive BNB rewards on each transaction
            </span>
            <button className="rounded-full bg-[#FF6E38] text-white">
                Learn More About Staking Here
            </button>
        </div>
    );
};
export default StakeHeading;
